import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../store/actions';

export const useSetExcludedGameCodes = () => {
    const dispatch = useDispatch();

    return useCallback(({
        excludedGameCodes
    }: {
        excludedGameCodes: string[];
    }) => {
        if (!Array.isArray(excludedGameCodes)) {
            return;
        }

        dispatch(actions.setExcludedGameCodes(excludedGameCodes));
    }, [
        dispatch
    ]);
};
